export function formatItemsCount(count: number): string {
  return `${count}\u00A0${count === 1 ? 'item' : 'items'}`;
}
